export default __webpack_public_path__ + "static/media/introLPBgMb.c46caa43.png";